module.exports = __webpack_public_path__ + "static/img/footer_wecode_4.3243020.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer_wecode_4.jpg
// module id = CQy0
// module chunks = 32